export default __webpack_public_path__ + "static/media/profit.e31368a9.png";